<template>
    <div>
      <v-container grid-list-xl class="word-wrap">
        <v-layout row wrap justify-center>
          <v-flex xs12 md12>
            <v-container fluid ma-0 pa-0>
              <v-layout row wrap justify-center>
                <v-flex xs12 md8 v-if="detailShow">
                    <survey-item-card
                      class="test-diagno mb-5"
                      :itemData="item"
                      :answerData="answerData"
                    />
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </template>
  
  <script>
  import SurveyService from "../../services/SurveyService";
  import SurveyItemCard from "../../components/Surveys/SurveyItemCard.vue";
  
  export default {
    data: () => {
      return {
        loading: false,
        item: {},
        answerData: [],
        page: 1,
        perPage: 50,
        paginationStop: false,
        detailShow:false,
      };
    },
    components: {
      SurveyItemCard,
    },
    methods: {
      getSurveyDetail() {
        this.loading = true;
        setPageLoading(true);
        SurveyService.getSurveyDetail(this.surveyId)
          .then((res) => {
            if(res.data){
            
            this.item = res.data;
            this.getAnswerSurvey();
          }
          })
          .catch((err) => {
            showError(err);
            this.loading = false;
          })
          .then(() => {
            setPageLoading(false);
          });
      },
  
      getAnswerSurvey() {
        SurveyService.getSurveyAnswersWithSurveyId(this.$store.state.user.Id, this.surveyId)
          .then((res) => {
            this.answerData = res.data;
            this.detailShow = true
          })
          .catch((err) => {
            showError(err);
          })
          .then(() => {
            setPageLoading(false);
            this.loading = false;
          });
      },
    },
    computed: {},
    mounted() {
        console.log('surveyId :' ,this.$route.params.id)
    if (this.$route.params.id) {
      this.surveyId = this.$route.params.id;
      this.getSurveyDetail();
    }else{
       this.getSurveyDetail(); 
    }
      
    },
    watch: {},
  };
  </script>
  
  <style>
  .fixed .v-card {
    position: fixed;
    min-width: 253.5px;
  }
  
  .fixed-in-flex {
    position: fixed;
  }
  
  .vue-sticky-el {
    z-index: 1 !important;
  }
  
  .word-wrap {
    word-break: break-word !important;
  }
  </style>
  